<div class="row" [ngClass]="{ 'd-none': viewMode === 'detail' }">
  <div class="col-md">
    <div class="input-group input-group-sm">
      <input
        type="text"
        #search
        [(ngModel)]="filter"
        class="form-control form-control-sm"
        placeholder="Nom, Uid, Propriétaire (code/nom)"
      />
      <span class="input-group-prepend">
        <span class="input-group-text">
          <i class="icofont icofont-search"></i>
        </span>
      </span>
    </div>
  </div>
</div>
<ng-container *ngIf="viewMode === 'list'">
  <div class="card">
    <button (click)="editCluster(undefined)" class="btn btn-sm btn-primary">
      <strong [innerHtml]="'+ajouter' | translate"></strong>
    </button>
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th [innerHtml]="'Cluster' | translate"></th>
            <th [innerHtml]="'IP' | translate"></th>
            <th [innerHtml]="'IPv6' | translate"></th>
            <th [innerHtml]="'UID' | translate"></th>
            <th>Template</th>
            <th [innerHtml]="'OrganizationOwner' | translate"></th>
            <th [innerHtml]="'Cache' | translate"></th>
            <th [innerHtml]="'Actions' | translate" style="width: 80px"></th>
          </tr>
        </thead>
        <tbody *ngIf="clusterPage">
          <ng-template
            ngFor
            let-row
            [ngForOf]="
              clusterPage.content
                | paginate
                  : {
                      itemsPerPage: pageRequest.size,
                      currentPage: pageRequest.number + 1,
                      totalItems: clusterPage.totalElements,
                    }
            "
          >
            <tr [ngClass]="{ closed: !row.opened }">
              <td>
                <a (click)="editCluster(row)">{{ row.name }}</a>
                <span *ngIf="row.managed" class="label ml-2 mr-2 badge-outline" title="{{ 'Managed' | translate }}"
                  >M</span
                >
              </td>
              <td>{{ row.ip }}</td>
              <td>{{ row.ipv6 }}</td>
              <td>{{ row.uid }}</td>
              <td>{{ row.type?.name }}</td>
              <td>
                <a [routerLink]="['/',ADMIN_PREFIX,ORGANIZATIONS_ROUTE,row.owner.code]">{{ row.owner.name }}</a>
                <app-badge-organization [code]="row.owner.code"></app-badge-organization>
              </td>
              <td>{{ (row.supportsCache ? 'enabled' : 'disabled') | translate }}</td>
              <td>
                <div class="actions">
                  <i (click)="editCluster(row)" class="icofont icofont-edit-alt"></i>
                  <i (click)="showModalDelete(row)" class="icofont icofont-ui-delete"></i>
                </div>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
      <div *ngIf="clusterPage" class="float-right mr-2">
        <pagination-controls
          class="pull-right"
          (pageChange)="changePage($event)"
          previousLabel="{{ 'Previous' | translate }}"
          nextLabel="{{ 'Next' | translate }}"
        ></pagination-controls>
        <div class="pull-right mr-4 total-admin">Total : {{ clusterPage.totalElements }}</div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="viewMode === 'detail'">
  <h4 class="mb-3">{{ (editMode == 'create' ? 'AjouterCluster' : 'EditerCluster') | translate }}</h4>
  <div class="card p-4">
    <div class="row">
      <div class="col-xxl-6">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label [innerHtml]="'OrganizationOwner' | translate"></label>
              <ng-select
                [items]="organizations"
                [multiple]="false"
                [closeOnSelect]="true"
                bindLabel="label"
                bindValue="code"
                [(ngModel)]="cluster.ownerCode"
                (search)="loadOrganizations($event.term)"
              ></ng-select>
            </div>
            <div class="form-group">
              <label [innerHtml]="'Name' | translate"></label>
              <input [(ngModel)]="cluster.name" class="form-control" type="text" />
            </div>
            <div class="form-group">
              <label [innerHtml]="'UID' | translate"></label>
              <input [(ngModel)]="cluster.uid" class="form-control" type="text" [disabled]="editMode == 'update'" />
            </div>
            <div class="form-group">
              <label [innerHtml]="'IP' | translate"></label>
              <input [(ngModel)]="cluster.ip" class="form-control" type="text" />
            </div>
            <div class="form-group">
              <label [innerHtml]="'IPv6' | translate"></label>
              <input [(ngModel)]="cluster.ipv6" class="form-control" type="text" trimToNull />
            </div>
            <div class="form-group">
              <label [innerHtml]="'Endpoint' | translate"></label>
              <input [(ngModel)]="cluster.endpoint" class="form-control" type="text" />
            </div>
            <div class="form-group">
              <label [innerHtml]="'Cluster twin' | translate"></label>
              <ng-select
                [items]="clustersTwin"
                [multiple]="false"
                [closeOnSelect]="true"
                bindLabel="name"
                bindValue="uid"
                [(ngModel)]="cluster.twinUid"
              />
            </div>
            <div class="form-group">
              <label [innerHtml]="'Elasticsearch'"></label>
              <ng-select
                [items]="elasticsearchs"
                [multiple]="false"
                [closeOnSelect]="true"
                bindLabel="label"
                bindValue="id"
                [(ngModel)]="cluster.elasticsearchId"
              />
            </div>
            <div class="form-group">
              <label [innerHtml]="'Template'"></label>
              <ng-select
                [items]="clusterTypes"
                [multiple]="false"
                [closeOnSelect]="true"
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="cluster.typeId"
              />
            </div>
            <div class="form-group">
              <label [innerHtml]="'Cluster outgoing IPs'"></label>
              <ng-select
                [multiple]="true"
                [closeOnSelect]="true"
                [(ngModel)]="cluster.trustedIps"
                [addTag]="true"
                bindValue="label"
              ></ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xxl-6">
        <div class="form-group">
          <label [innerHtml]="'Default site mode'"></label>
          <select [(ngModel)]="cluster.defaultSiteMode" class="form-control">
            <option *ngFor="let m of hostModeService.modes" [value]="m.value">{{ m.value }}</option>
          </select>
        </div>
        <div class="form-group">
          <label [innerHtml]="'Public'"></label>
          <app-switch [(ngModel)]="cluster.isPublic" />
        </div>
        <div class="form-group">
          <label [innerHtml]="'Ouvert'"></label>
          <app-switch [(ngModel)]="cluster.opened" />
        </div>
        <div class="form-group">
          <label [innerHtml]="'Managed'"></label>
          <app-switch [(ngModel)]="cluster.managed" />
        </div>
        <div class="form-group">
          <label [innerHtml]="'Supports Cache'"></label>
          <app-switch [(ngModel)]="cluster.supportsCache" />
        </div>
        <div class="form-group">
          <label [innerHtml]="'Supports IPv6 origins'"></label>
          <app-switch [(ngModel)]="cluster.supportsIpv6Origins" />
        </div>
        <div class="form-group">
          <label [innerHtml]="'Supports mTLS'"></label>
          <app-switch [(ngModel)]="cluster.supportsMtls" />
        </div>
        <div class="form-group">
          <label [innerHtml]="'Supports challenge'"></label>
          <app-switch [(ngModel)]="cluster.supportsChallenge" />
        </div>
        <div class="form-group">
          <label [innerHtml]="'CDN ID'"></label>
          <input [(ngModel)]="cluster.cdnId" class="form-control" type="text" />
        </div>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button
      *ngIf="editMode == 'create'"
      (click)="onCreateCluster(cluster)"
      class="btn btn-sm btn-danger mr-2"
      [innerHtml]="'ajouter' | translate"
    ></button>
    <button
      *ngIf="editMode == 'update'"
      (click)="onUpdateCluster(cluster)"
      class="btn btn-sm btn-danger mr-2"
      [innerHtml]="'Enregistrer' | translate"
    ></button>
    <button (click)="setListMode()" class="btn btn-sm btn-primary mr-2" [innerHtml]="'Annuler' | translate"></button>
  </div>
</ng-container>

<app-modal-basic #modalDelete class="modal-delete">
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'Cluster.confirmDelete' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="modalDelete.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="selectedCluster" class="app-modal-body">
    <div class="row">
      <div class="col-md-12">
        <form>
          <div class="form-group">
            <label>{{ 'Cluster' | translate }} :</label>
            <input type="text" value="{{ selectedCluster.name }}" class="form-control form-control-sm" readonly />
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button
      name="validate-delete"
      (click)="deleteCluster(selectedCluster); hideModalDelete()"
      class="btn btn-primary btn-sm"
      [innerHTML]="'delete' | translate"
    ></button>
    &nbsp;
    <button (click)="hideModalDelete()" class="btn btn-danger btn-sm" [innerHTML]="'Fermer' | translate"></button>
  </div>
</app-modal-basic>
